import React, { memo, useEffect, useState } from 'react';
import { isMobile } from "react-device-detect";
import Dialog from '@mui/material/Dialog';
import { Icon } from './Icon';
import { VerificationForm } from "../components/VerificationForm";
import { VerityType } from "../types/types";
import { useHistory } from "react-router-dom";

interface VerificationPopup {
  title: string;
  description?: string;
  description2?: string | false;
  buttonText: string;
  open: boolean;
  onClose: () => void;
}

export const VerificationPopup = memo(({
                                         title,
                                         description,
                                         description2,
                                         buttonText,
                                         open,
                                         onClose,
                                       }: VerificationPopup) => {
  const [_isMobile, setMobile] = useState(false);
  const history = useHistory();

  useEffect(() => {
    setMobile(isMobile);
  }, [isMobile]);

  if (!open) return <></>;
  return (
      <>
        <Dialog
            open
            onClose={onClose}
            className={`VFC md:max-w-xl md:m-auto`}
            fullWidth
        >
          <div className={`w-full flex flex-col gap-y-2 text-13 py-8 md:px-5 px-4 bg_3e52bb text-white`}>
            <div className={`flex justify-between text-16 font-semibold`}>
              {title && (<p>{title}</p>)}
              <Icon.X className={`wh-6 cursor-pointer bg-gray-400 rounded-full p-1`} onClick={onClose} />
            </div>
            {description && (<p className="text-12 mt-2">{description}</p>)}
            <div className={`text-gray-500 border-b mb-5 pb-5`}>
              {description2 && (
                  <div
                      className={`text-white leading-5 text-12`}
                      dangerouslySetInnerHTML={{ __html: description2 }}
                  />
              )}
            </div>
            <VerificationForm
                returnUrl={history.location.pathname}
                buttonText={buttonText}
                verifyType={VerityType.BASIC}
                className={`text-white`}
                innerTxtColor={`tx_FFE500`}
                buttonColor={`tx_3e52bb bg-white`}
                innerTxtColor2={`text-white`}
            />
          </div>
        </Dialog>
      </>
  );
});
